export enum EntityCodes {
  Glitch = 'Glitch',
  Complain = 'Complain',
  Reservation = 'Reservation',
  Guest = 'Guest',
  Trace = 'Trace',
  RoomStatus = 'RoomStatus',
  QueueRoom = 'QueueRoom',
  Asset = 'Asset',
  AssetCode = 'AssetCode',
  Location = 'Location',
  AssetCategory = 'AssetCategory',
  PM = 'PM',
  WorkOrder = 'WorkOrder',
  Task = 'Task',
  TaskGroup = 'TaskGroup',
  CheckList = 'CheckList',
  Staff = 'Staff',
  Skill = 'Skill',
  Department = 'Department',
  PMType = 'PMType',
  UserGroup = 'UserGroup',
  CheckListItem = 'ChecklistItem',
  Metric = 'Metric',
  MeasurementUnit = 'MeasurementUnit',
  Reasons = 'Reasons',
  WODescription = 'WODescription',
  WOTypes = 'WOTypes',
  Currency = 'Currency',
  WOSources = 'WOSources',
  WONumber = 'WONumber',
  JobDescription = 'JobDescription',
  WhitelistDept = 'WhitelistDept',
  StdReport = 'StandardReport',
  Language = 'Language',
  ParentWO = 'ParentWO',
  WOAndJobDescription = 'WOAndJobDescription',
}

// export enum ObjectStatuses {
//   Active = 1,
//   Deleted = 2,
//   Disabled = 3,
// }
export enum ObjectStatuses {
  Active = 1,
  Deleted = 2,
  Disabled = 3,
  Pending = 4,
  Completed = 5,
  PendingApproval = 6,
  RejectApproval = 7,
  ApprovedApproval = 8,
  LinkWOCreated = 9,
}

export enum WOObjectStatuses {
  Disabled = 0,
  Active = 1,
  All = undefined,
}

export enum WOSourceStatuses {
  Service = 1,
  PM = 2,
  Corrective = 3,
  All = undefined,
}

export enum BulkActionType {
  UnKnown = 0,
  WorkOrderCancel = 4,
  WorkOrderAssign = 5,
  WorkOrderPark = 7,
  WorkOrderComplete = 9,
  AssetBulkDelete = 10,
  PMBulkDelete = 11,
  PMBulkEnable = 13,
  PMBulkDisable = 14,
  WorkOrder = 12,
}

export enum EntityActions {
  None = 0,
  Add = 1,
  Delete = 2,
  Edit = 3,
  Cancel = 4,
  Assign = 5,
  Reassign = 6,
  Park = 7,
  Complete = 9,
  Reopen = 10,
  Start = 15,
  Delay = 16,
  AddAsset = 20,
  AddRemarks = 21,
  AddAttachment = 22,
  RecordMetric = 23,
  ChangeAsset = 24,
  ChangeChecklist = 25,
  UpdateInvoiceCost = 26,
  Rename,
  EditSchedule,
  Activate,
  Deactivate,
  Print,
  Clone,
  Approval,
  CreateApproval,
  EditApproval,
  ApproveApproval,
  RejectApproval,
  ChangeAttachment,
  DeleteJobAttachment,
  LinkWOCreated,
  WOAutomationFailure,
  WOBackOrder,
}

export enum NotificationEvents {
  Add = 1,
  Assign = 5,
  Park = 7,
  Complete = 9,
  Reopen = 10,
  Start = 15,
  Delay = 16,
  Checklist = 30,
  PM = 61,
  AutoFail = 41,
  Approval = 36,
  Rejection = 37,
}

export enum AssetTxnType {
  Create = 0,
  Update = 1,
  Delete = 2,
}
export enum TriggerTypes {
  OnStart = 1,
  OnClose = 2,
}

export enum FilterTypes {
  Properties,
  Locations,
  Assets,
  AssetCategories,
  ObjectStatus,
  PMType,
  WODescription,
  JobDescription,
  AssignedStaff,
  WOSource,
  PM,
  HasSchedule,
  ScheduleType,
  Skills,
  Department,
  Designation,
  MetricTypes,
  Metrics,
}

export enum RestartAssignmentRules {
  Reassign = 1,
  SameUser = 2,
}

export enum InputBoolean {
  True = 1,
  False = 2,
}

export enum InputHealthStatus {
  Healthy = 1,
  Warning = 2,
  Unhealthy = 3,
}

export enum UIActions {
  Select = 'Select',
  Click = 'Click',
}

export enum ReasonType {
  Park = 1,
  Reassign = 2,
  Close = 3,
  Reopen = 4,
}

export enum LocationTypes {
  GuestRoom = 'R',
  Public = 'M',
  Engineering = 'E',
  Other = 'Ot',
}

export class AuthActionCodes {
  public static Audit_View = 'KM_ADTVIEW';

  public static Asset_Category_Add_Edit = 'KM_ASTCTUP';
  public static Asset_Category_Console_View = 'KM_ASTVIEW';

  public static Asset_Metric_Input = 'KM_ASTMTIN';
  public static Asset_Metric_Update = 'KM_ASTMTUP';
  public static Asset_Parts_Update = 'KM_ASTPTUP';

  public static Asset_Add = 'NAST_AE';
  public static Asset_Edit = 'ACNSL_AE';
  public static Asset_Delete = 'ACNSL_DEL';
  public static Asset_Console_View = 'ACNSL_VW';

  public static Checklist_Add = 'KM_CHKAD';
  public static Checklist_Edit = 'KM_CHKUP';
  public static Checklist_Console_View = 'KM_CHKVIEW';

  public static Metrics_Add_Edit = 'KM_METUP';
  public static Metric_Console_View = 'KM_METVIEW';

  public static UserGroup_Add_Edit = 'KM_UGUP';
  public static UserGroup_Console_View = 'KM_UGVIEW';

  public static PM_Add = 'KM_PMADD';
  public static PM_Edit = 'KM_PMEDIT';
  public static PM_Console_View = 'KM_PMVIEW';

  public static WorkOrder_Add = 'KM_WOREG';
  public static WorkOrder_Edit = 'KM_WOEDIT';
  public static WorkOrder_Action = 'KM_WOACT';
  public static WorkOrder_Closed_Action = 'KM_CL_WO_ACTION';
  public static WorkOrder_Console_View = 'KM_WOVIEW';

  public static Report_Run = 'RPT_KM_RUN';
  public static Approval = 'KM_WOAPPR';
  public static Invoice_Details = 'KM_WOINV';
  public static WO_Complete_KSV = 'CALL_CLO';
  public static WO_Park_KSV = 'CALL_PRK';
  public static WO_Reassign_KSV = 'CALL_RAS';
  public static WO_Reopen_KSV = 'CALL_ROPN';
  public static MNT_Config_View = 'KMCONFIG_VW';
  public static MNT_Config_Add_Edit = 'KMCONFIG_AE';
  public static WorkOrder_Add_Attachment = 'KM_WO_ADD_ATTACH';
  public static WorkOrder_Delete_Attachment = 'KM_WO_DEL_ATTACH';
  public static WorkOrder_Print = 'KM_WO_PRINT';
  public static WorkOrder_Reopen_Action = 'KM_WO_REOPEN';
  public static WorkOrder_Asset_Action = 'KM_WOADD';
  public static WorkOrder_Park = 'KM_WO_PARK';
  public static WorkOrder_Assign = 'KM_WO_REASSIGN';
  public static WorkOrder_Start = 'KM_WO_START';
  public static WorkOrder_Invoice = 'KM_WOINV';
  public static WorkOrder_Approval = 'KM_WOAPPR';
  public static WorkOrder_Checklist_Action = 'KM_WO_MNG_CHECKLIST';
  public static Workorder_New_Attachment = 'KM_WO_ATTACH';
}

export class ModuleLicenceCodes {
  public static KMTCore = 'KMT_CORE';
  public static TritonCore = 'TTN_CORE';
  public static ServiceCore = 'TTN_RRESP';
  public static InventoryCore = 'UF_INV';
}

export enum SortDirection {
  Desc = 0,
  Asc = 1,
}

export enum NodeSortDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum CalendarViews {
  Year,
  Month,
  Day,
  Week,
}

export enum CalendaFields {
  LocationName,
  PMName,
  SkillName,
  DepartmentName,
  TechnicianName,
}

export enum WOTypeCategory {
  KSV = 1,
  Preventive = 2,
  Other = 3,
}

export enum TranslatedEntities {
  Asset = 'Asset',
  AssetCategory = 'AssetCategory',
  CostCenter = 'CostCenter',
  WODescription = 'WODescription',
  WOType = 'WOType',
  Checklist = 'Checklist',
  ChecklistItem = 'ChecklistItem',
  Reason = 'Reason',
  PM = 'PM',
}

export enum PageRights {
  Add,
  Edit,
  View,
}

export enum Modules {
  WorkOrder = 'KMWO',
  PM = 'KMPM',
}
